import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { MyInput } from "..";
const MyAutocomplete = ({
  label,
  options,
  onChange,
  error,
  helperText,
  ...rest
}) => {
  // const options = [
  //   { label: "The Godfather", id: 1 },
  //   { label: "Pulp Fiction", id: 2 },
  // ];
  return (
    <>
      <Autocomplete
        {...rest}
        id="combo-box-demo"
        onChange={onChange}
        options={options}
        isOptionEqualToValue={(option, value) => 
          // eslint-disable-next-line
          option.id == value?.id
        }
        // sx={{ width: 300 }}
        size="small" // Make dropdown items compact
        renderOption={(props, option) => {
          const { key, ...otherProps } = props;
          return (
            <li key={option.id || key} {...otherProps}>
              {option.label}
            </li>
          );
        }}
        renderInput={(params) => (
          <MyInput
            {...params}
            label={label}
            error={error}
            helperText={helperText}
            size="small" // Make input compact
            sx={{
              width: "100%",
              "& .MuiOutlinedInput-root": {
                height: "42px", // Increased from 36px
                padding: "0 8px !important", // Remove vertical padding to let flex align center
                borderRadius: "8px",
                backgroundColor: "#fff",
                display: "flex", // Ensure flex layout
                alignItems: "center", // Vertically center content
                "& fieldset": {
                  borderColor: "#e5e7eb",
                },
                "&:hover fieldset": {
                  borderColor: "#f06524",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#f06524",
                  borderWidth: "1px",
                  boxShadow: "0 0 0 3px rgba(240, 101, 36, 0.1)",
                },
                // Adjust input inside
                "& .MuiAutocomplete-input": {
                  padding: "0 4px !important", // Remove input padding
                  fontSize: "13px",
                  height: "auto",
                },
                // Adjust end adornment (arrow/clear)
                "& .MuiAutocomplete-endAdornment": {
                  top: "calc(50% - 12px)", // Center vertically
                },
              },
              "& .MuiInputLabel-root": {
                fontSize: "13px",
                color: "#6b7280",
                zIndex: 5, // Force label above background
                transform: "translate(14px, 10px) scale(1)", // Adjusted for 42px height (Center)
                pointerEvents: "none", // Prevent click blocking
              },
              "& .MuiInputLabel-root.MuiInputLabel-shrink": {
                transform: "translate(14px, -9px) scale(0.75)", // Position on border
                padding: "0 4px",
                backgroundColor: "#fff", // Mask border
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "#f06524",
              },
            }}
          />
        )}
      />
    </>
  );
};

export default MyAutocomplete;
